<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<path d="M11,1v10H1V1H11z M10,2H2v8h8V2z" />
</svg>
</template>